import Icon from '@klv/atoms/icon';

import { useTranslation } from '@klv/hooks/useTranslation';
import { generateClassName } from '@klv/shared/utils/functions';

import type { IUserCourseData } from './types';
import * as s from './styles/unified-search-result-grid-item.module.css';

const CourseList = ({ courses }: IUserCourseData) => {
  const { t } = useTranslation();

  return (
    <div>
      {courses.map(course => {
        if (course.completed_at !== null && course.completed_lesson_count === course.total_lesson_count) {
          return (
            <div key={course.third_party_id} className={s.courseStatus}>
              <Icon aria-hidden='true' color='currentColor' iconName='CheckBullet' />
              <div className={generateClassName(['p3', 'semiBold'])}>
                {t('academy_courseStatus_completed')}
              </div>
            </div>
          );
        } else if (course.completed_lesson_count === 0 && course.total_lesson_count > 0) {
          return (
            <div key={course.third_party_id} className={s.courseStatus}>
              <Icon aria-hidden='true' color='currentColor' iconName='Academy' />
              <div className={generateClassName(['p3', 'semiBold'])}>
                {t('academy_courseStatus_registered')}
              </div>
            </div>
          );
        } else if (course.completed_lesson_count > 0) {
          const courseInfoPercentage = Math.round((course.completed_lesson_count / course.total_lesson_count) * 100);
          return (
            <div key={course.third_party_id} className={s.courseStatus}>
              <Icon aria-hidden='true' color='currentColor' iconName='ClockAndDelay' />
              <div className={generateClassName(['p3', 'semiBold'])}>
                {`${t('academy_courseStatus_inProgress_startingText')} (${courseInfoPercentage}%) ${t('academy_courseStatus_inProgress_endingText')}`}
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default CourseList;
